/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Box } from "@mui/material";

const TabPanel = (props) => {

    const {
        children,
        value,
        index,
        ...other
    } = props;

    const sx = { pl: 3, pr: 3, pt: 0, pb: 0 };

    return (
        <div
            role='tabpanel'
            className='image-selector-tabpanel'
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            style={{ height: "calc(100% - 115px)" }}
        >
            {value === index && 
                <Box style={{ height: "100%" }} sx={sx}>{children}</Box>
            }
        </div>
    );
};

export { TabPanel };
